import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-checkbox-text',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './checkbox-text.component.html',
    styleUrl: './checkbox-text.component.css'
})
export class CheckboxTextComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  showError: boolean = false;

  constructor() {}
  ngOnInit() {}

  onCheckboxChange(): boolean {
    const control = this.formGroup.get(this.fields.fieldName);

    if (control?.value === true) {
      this.showError = false;
      control.markAsTouched();
      return true;
    } else {
      this.showError = true;
      control?.markAsUntouched();
      return false;
    }
  }

  get formattedDisplayName(): string {
    return this.fields.displayName?.replace(/aggree/gi, 'agree') || '';
  }
}
